import { MENU_CHANNELS, MENU_FULFILLMENT_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
const options = {
    max: null,
    min: 0,
    toppings: false,
    channels: ['pos', 'online', 'marketplace'],
    displayType: 'custom',
};
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'fulfillmentType',
            options: MENU_FULFILLMENT_TYPES,
            type: 'Select',
        },
        {
            name: 'toppings',
            type: 'Boolean',
        },
        {
            name: 'channels',
            options: MENU_CHANNELS,
            type: 'Select',
        },
    ],
    hasDescription: false,
    hasHours: false,
    hasImage: false,
    hasVariations: false,
    hasPos: true,
    hasPresentation: true,
    lists: [
        {
            collection: 'Modifier',
            name: 'modifiers',
            preselectedList: 'preselectedModifiers',
            primaryRelationship: true,
        },
        {
            collection: 'Modifier',
            isPreselectionList: true,
            name: 'preselectedModifiers',
            sourceList: 'modifiers',
        },
    ],
    name: 'ModifierSet',
    options,
    pluralizedName: 'ModifierSets',
    sellable: false,
    sortKeys: [],
    unlinkedOptions: [],
    version: 6,
});
//# sourceMappingURL=modifierSet.js.map